import { URL } from '../../../../config'
import { getRequest } from '../../../../utils/httpRequest'

export const getGames = function (eventId,schoolId,eventdivision,eventgender,token) 
{
  //console.log("GetGames:eventId,schoolId,division,gender,toke",eventId,schoolId,eventdivision,eventgender,token);
  const gamesEndpoint = `/games/${eventId}/${schoolId}/${eventdivision}/${eventgender}`
  const  participantGamesURL     =  `${URL.postevent}${gamesEndpoint}` 
  return getRequest(participantGamesURL,'json',token)
}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/getGames.js